import { useNavigatePage } from "../../hooks/useNavigatePage";
import { BtnBox } from "../../style/common";
import Btn from "../common/Btn";
import GoBackBtn from "../common/GoBackBtn";

interface BtnsProps {
  idx: string;
  pwResetOnClick?: () => void;
  signoutOnClick?: () => void;
}

export default function Btns({ idx, pwResetOnClick, signoutOnClick }: BtnsProps) {
  const { onMovementPage } = useNavigatePage();

  return (
    <BtnBox>
      <Btn type="button" title="비밀번호 초기화" color="blue" onClick={pwResetOnClick} />
      <Btn type="button" title="수정" color="orange" onClick={() => onMovementPage(`/user/detail/${idx}?mode=edit`)} />
      {signoutOnClick && <Btn type="button" title="탈퇴" color="red" onClick={signoutOnClick} /> }
      <GoBackBtn />
    </BtnBox>
  );
}
